// Google Map Get Info Lat,Long
export const GOOGLE_MAP_GET_INFO_URL ="https://maps.googleapis.com/maps/api/geocode/json?latlng="

// ** ================== API URLs ================== **
 export const SITE_DOMAIN = "https://api.gootech.app/" //"https://food.akwade.net/";
// ** API POINT DOMAIN
export const API_POINT_DOMAIN = "https://api.gootech.app/api/" //"https://food.akwade.net/api/"

// ** Countries && Cities
export const API_COUNTRIES_URL= "country"
export const API_CITIES_URL= "city"

// ** Auth URL's
export const API_SIGNUP_URL ="customer/signup"
export const API_SIGNIN_URL ="customer/login"
export const API_PROFILE_URL ="customer/profile"

// ** API CATEGORIS URL
export const API_CATEGORIS_URL = "categories"
// ** API SLIDER URL
export const API_SLIDER_URL = "slider/app"

// ** API MEALS WHERE CATEGORY ID URL
// export const API_MEALES_WHERE_CATEGORY_URL = "category"

export const API_MEALS_RATE_URL = "meal_rate?rate=0"

export const API_ONBOARDING_URL = "onboardings_user"



